import type { ReactNode } from 'react'

interface TagPillProps {
  children: ReactNode
  active?: boolean
  onClick?: () => void
}

export function TagPill({ children, active, onClick }: TagPillProps) {
  return (
    <button type="button" className="cg-tag" data-active={active} onClick={onClick}>
      {children}
    </button>
  )
}
